<script setup lang="ts">
	import { ref, computed, onMounted } from 'vue';
	import { useAutocomplete, SuggestResult } from './Autocomplete';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	
	const props = defineProps({
		restApi: String,
		params: String,
		suggestEmpty: Boolean,
		size: Number,
		placeholder: String,
		tabindex: Number,
		name: String,
		value: String,
		modelValue: String,
		mode: String,
		focus: Boolean,
		suggClazz: String,
	});
	
	const suggesterClass = props.suggClazz?props.suggClazz:'autocompleteList';
	
	const input = ref(null);
	
	const emit = defineEmits(['update:modelValue','updateInputValue']);
	defineExpose({focus});
	
	const { results, selected, errorMessage, isError, progress, inputValue,
		sendData, selectResult, selectSelectedResult, resetValue, suggestedKey,  
		setSelected, goUp, goDown, focusOut, pickSelected } = useAutocomplete(props,emit,afterSelectResult);
		
	function canSendData(): boolean {
		//console.log("suggestEmpty:"+props.suggestEmpty+" path value:"+pathFolder.value.length);
		return props.suggestEmpty || (pathFolder.value && pathFolder.value.length>=3);
	}
	
	function afterSelectResult(result: SuggestResult): void {
		focus();
	}
	
	function focus(): void {
		input.value.focus();
	}
	
	const pathFolder = computed(() => {
		if (inputValue.value && inputValue.value.length>0) {
			let index = inputValue.value.lastIndexOf("/");
			if (index>0) {
				return inputValue.value.substring(0,index);
			}
		}
		return inputValue.value;
	});
	
	onMounted(() => {
		if (props.focus) {
			focus();
		}
	});
	
</script>
<template>
<div class="autocompleteDiv">
	<span style="white-space: nowrap;">
		<input ref="input" :name="name" type="text" v-model="inputValue" maxlength="127" :size="size" :tabindex="tabindex"
		 @keydown.up.capture.stop="goUp" @keydown.down.capture.stop="goDown" @focusout="focusOut"
		 @keydown.enter.capture.stop.prevent="selectSelectedResult" @keyup.enter.capture.stop
		 @keyup.up.capture.stop @keyup.down.capture.stop :disabled="pickSelected"
		 @keyup="sendData(canSendData())" :placeholder="placeholder" autocomplete="off" class="suggfield">
		<sym-icon name="close" v-show="pickSelected" style="padding-left: 5px;" 
		class="close-cross activeclick" @click="resetValue" />
	</span>
	<ul v-if="results.length>0" :class="suggesterClass">
		<li v-for="(item,index) in results" class="autocompleteItem" :class="{ autocompleteItemSel: selected===index }" :key="item.key"
			 @click="selectResult(item)" @mouseenter="setSelected(index)" >{{item.value}}</li>
	</ul>
	<div class="errors" v-show="isError"><span class="perr">{{errorMessage}}</span></div>
</div>
</template>

<style>
</style>
